 




// import { ntxAPI } from '@API/axiosNeatex';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import type { APIResponse } from '@store/Shared/shared';
// import { TreeSelect } from 'antd';
// import React, { useMemo, useState } from 'react';
// import { Table, Spinner, Form, Row, Col, Button, Alert, CardHeader, Badge } from 'react-bootstrap';
// import Select from 'react-select';
// import * as XLSX from 'xlsx';
// import { Link } from 'react-router-dom';

// // ======================
// // Types
// // ======================
// interface ApLedgerRow {
//   id: string;

//   invId?: string | null;
//   purId?: string | null;
//   paymentId?: string | null;

//   transDate: string; // ISO

//   purCode?: string | null;
//   invCode?: string | null;

//   docNo: string | null;
//   docType: string;
//   description: string;

//   debit: number;
//   credit: number;
//   runningBalance: number;
// }

// const n = (v: any) => {
//   const x = Number(v);
//   return Number.isFinite(x) ? x : 0;
// };

// const formatAmount = (amount: number): string => new Intl.NumberFormat('en-US').format(n(amount));

// const getDocTypeAr = (docType?: string) => {
//   if (!docType) return '-';
//   const k = docType.replace(/\s+/g, '').toLowerCase();

//   if (k === 'openingbalance') return 'الرصيد السابق';
//   if (k === 'closingbalance') return 'الرصيد الختامي';

//   if (k === 'creditmemo') return 'إشعار مدين';
//   if (k === 'invoice') return 'فاتورة';
//   if (k === 'payment') return 'سداد';

//   // الداتا الجديدة عندك: Standard
//   if (k === 'standard') return 'قياسي';

//   return 'قياسي';
// };

// const safeFileName = (s: string) => s.replace(/[\\/:*?"<>|]/g, '_');

// // ======================
// // ✅ عدّل المسارات حسب Routing عندك
// // ======================
// const ROUTES = {
//   // apInvoice: (id: string) => `/AP/Invoices/${id}`, // مثال  /INV/Transactions/InvReceive/3a8e1644-861b-4aba-a9ae-dd8e2a38efe7/UpdateInvReceive
//   apInvoice: (id: string) => `/INV/Transactions/InvReceive/${id}/UpdateInvReceive`, // مثال  /INV/Transactions/InvReceive/3a8e1644-861b-4aba-a9ae-dd8e2a38efe7/UpdateInvReceive
//   purchase: (id: string) => `/PUR/PurchaseOrder/${id}/UpdatePurchaseOrder`, // مثال  /PUR/PurchaseOrder/08737d7f-b54d-401a-9e21-ab3cdf1ff122/UpdatePurchaseOrder
//   apPayment: (id: string) => `/AP/ApPayments/${id}/UpdateApPayments` // مثال/AP/ApPayments/888882c3-1f09-40a4-aa50-0387a7695983/UpdateApPayments
  
// };

// // ======================
// // Component
// // ======================
// const ApLedgerTransactionsReport: React.FC = () => {
//   const { treeSuppliersData } = useGetSuppliersList();
//   const { OperatingUnitOptions, loading: loadingOU } = useGetOperatingUnitWithPermission();

//   const [data, setData] = useState<ApLedgerRow[]>([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState<string | null>(null);

//   // Filters
//   const [organizationId, setOrganizationId] = useState<string>(''); // GUID
//   const [selectedSupplier, setSelectedSupplier] = useState<any>(null); // PeopleId
//   const [fromDateStr, setFromDateStr] = useState<string>(''); // yyyy-MM-dd
//   const [toDateStr, setToDateStr] = useState<string>(''); // yyyy-MM-dd

//   const resetFilters = () => {
//     setOrganizationId('');
//     setSelectedSupplier(null);
//     setFromDateStr('');
//     setToDateStr('');
//     setData([]);
//     setError(null);
//   };

//   const fetchData = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       if (!selectedSupplier) {
//         setError('اختر المورد أولاً');
//         setLoading(false);
//         return;
//       }

//       let s = fromDateStr;
//       let e = toDateStr;

//       if (s && e) {
//         const ds = new Date(s).getTime();
//         const de = new Date(e).getTime();
//         if (Number.isFinite(ds) && Number.isFinite(de) && ds > de) {
//           const tmp = s;
//           s = e;
//           e = tmp;
//         }
//       }

//       const params = {
//         StartDate: s,
//         EndDate: e,
//         OrganizationId: organizationId,
//         PeopleId: selectedSupplier
//       };

//       const res = await ntxAPI.get<APIResponse<ApLedgerRow[]>>('Reports/GetApLedgerTransactionsReport', { params });

//       if (res.data?.succeeded === true) {
//         setData(Array.isArray(res.data.data) ? res.data.data : []);
//       } else {
//         setError(res.data?.message || 'حدث خطأ غير معروف');
//       }
//     } catch (err: any) {
//       setError(err instanceof Error ? err.message : 'حدث خطأ غير معروف');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ======================
//   // Summary
//   // ======================
//   const summary = useMemo(() => {
//     const rows = data || [];
//     const totalDebit = rows.reduce((a, r) => a + n(r.debit), 0);
//     const totalCredit = rows.reduce((a, r) => a + n(r.credit), 0);

//     const endingBalance = rows.length ? n(rows[rows.length - 1].runningBalance) : 0;

//     const closing = rows.find(r => (r.docType || '').toLowerCase().includes('closing'))?.runningBalance ?? null;

//     return { totalDebit, totalCredit, endingBalance, closing };
//   }, [data]);

//   // ======================
//   // Excel Export (XLSX فقط)
//   // ======================
//   const exportToExcel = () => {
//     if (!data?.length) return;

//     const rows = data.map(r => ({
//       التاريخ: r.transDate ? new Date(r.transDate).toLocaleDateString('en-US') : '',
//       'رقم المستند': r.docNo ?? '-',
//       'مرجع المشتريات': r.purCode ?? '',
//       'مرجع الفاتورة': r.invCode ?? '',
//       النوع: getDocTypeAr(r.docType),
//       دائن: n(r.credit),
//       مدين: n(r.debit),
//       'الرصيد التراكمي': n(r.runningBalance),
//       // 'InvoiceId': r.invId ?? '',
//       // 'PurchaseId': r.purId ?? '',
//       // 'PaymentId': r.paymentId ?? ''
//     }));

//     const ws = XLSX.utils.json_to_sheet(rows);

//     ws['!cols'] = [
//       { wch: 12 },
//       { wch: 18 },
//       { wch: 16 },
//       { wch: 16 },
//       { wch: 14 },
//       { wch: 14 },
//       { wch: 14 },
//       { wch: 18 },
//       { wch: 36 },
//       { wch: 36 },
//       { wch: 36 }
//     ];

//     const wb = XLSX.utils.book_new();
//     (wb as any).Workbook = { Views: [{ RTL: true }] };
//     XLSX.utils.book_append_sheet(wb, ws, 'كشف الحساب');

//     const fileName = safeFileName(
//       `AP_Ledger_${selectedSupplier || 'Supplier'}_${fromDateStr || 'ALL'}_${toDateStr || 'ALL'}.xlsx`
//     );

//     XLSX.writeFile(wb, fileName);
//   };

//   // ======================
//   // ✅ بناء روابط المراجع حسب Ids
//   // ======================
//   const renderRefs = (r: ApLedgerRow) => {
//     const items: React.ReactNode[] = [];

//     if (r.invId) {
//       items.push(
//         <Link
//           key={`inv-${r.invId}`}
//           to={ROUTES.apInvoice(r.invId)}
//           className='text-decoration-none'
//           title='فتح تفاصيل الحركة المخزنيـة'
//         >
//           <Badge bg='info' className='me-1 bg-opacity-25 text-body w-100'>
//             {r.invCode || 'الحركة المخزنية'}
//           </Badge>
//         </Link>
//       );
//     }

//     if (r.purId) {
//       items.push(
//         <Link
//           key={`pur-${r.purId}`}
//           to={ROUTES.purchase(r.purId)}
//           className='text-decoration-none'
//           title='فتح تفاصيل المشتريات'
//         >
//           <Badge bg='success' className='me-1 bg-opacity-25 text-body w-100'>
//             {r.purCode || 'مشتريات'}
//           </Badge>
//         </Link>
//       );
//     }

//     if (r.paymentId) {
//       items.push(
//         <Link
//           key={`pay-${r.paymentId}`}
//           to={ROUTES.apPayment(r.paymentId)}
//           className='text-decoration-none'
//           title='فتح تفاصيل السداد'
//         >
//           <Badge bg='success' className='me-1'>
//             سداد
//           </Badge>
//         </Link>
//       );
//     }

//     return items.length ? <div className='d-flex flex-wrap gap-1'>{items}</div> : <span className='text-muted'>-</span>;
//   };

//   return (
//     <div>
//       <Card className='border-0'>
//         <CardBody>
//           {error && (
//             <Alert variant='danger' className='mb-4'>
//               خطأ في تحميل البيانات: {error}
//             </Alert>
//           )}

//           {/* Filters */}
//           <Card className='mb-4'>
//             <CardHeader className='d-flex justify-content-between align-items-center'>
//               <div className='mb-0'>الفلاتر</div>

//               {data.length > 0 && (
//                 <div className='d-flex align-items-center gap-2'>
//                   <span className='me-2'>عدد السطور: {data.length}</span>

//                   <Button variant='success' size='sm' onClick={exportToExcel}>
//                     <i className='fas fa-file-excel me-1'></i>
//                     تصدير Excel
//                   </Button>
//                 </div>
//               )}
//             </CardHeader>

//             <CardBody>
//               <Form>
//                 <Row className='g-3'>
//                   <Col md={4}>
//                     <Form.Group controlId='orgFilter'>
//                       <Form.Label>وحدة التشغيل</Form.Label>
//                       <Select
//                         classNamePrefix='react-select'
//                         isLoading={loadingOU}
//                         isSearchable
//                         isClearable
//                         options={OperatingUnitOptions}
//                         onChange={(option: any) => setOrganizationId(option?.value ?? '')}
//                         placeholder='حدد وحدة التشغيل'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={4}>
//                     <Form.Group controlId='supplierFilter'>
//                       <Form.Label>المورد</Form.Label>
//                       <TreeSelect
//                         showSearch
//                         className='w-100'
//                         treeLine
//                         allowClear
//                         treeDefaultExpandAll={false}
//                         value={selectedSupplier}
//                         onChange={(option: any) => setSelectedSupplier(option === null ? null : option)}
//                         treeData={treeSuppliersData}
//                         treeNodeFilterProp='title'
//                         placeholder='اختر المورد'
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={4}>
//                     <Form.Group controlId='fromDateFilter'>
//                       <Form.Label>من</Form.Label>
//                       <Form.Control
//                         type='date'
//                         value={fromDateStr}
//                         onChange={e => setFromDateStr(e.target.value)}
//                         max={toDateStr || undefined}
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col md={4}>
//                     <Form.Group controlId='toDateFilter'>
//                       <Form.Label>إلى</Form.Label>
//                       <Form.Control
//                         type='date'
//                         value={toDateStr}
//                         onChange={e => setToDateStr(e.target.value)}
//                         min={fromDateStr || undefined}
//                       />
//                     </Form.Group>
//                   </Col>

//                   <Col xs={12} className='text-end'>
//                     <Button variant='secondary' onClick={resetFilters} className='me-2'>
//                       تصفير الفلاتر
//                     </Button>

//                     <Button variant='primary' onClick={fetchData} disabled={loading}>
//                       {loading ? (
//                         <>
//                           <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' className='me-2' />
//                           جاري التحميل...
//                         </>
//                       ) : (
//                         'تحميل البيانات'
//                       )}
//                     </Button>
//                   </Col>
//                 </Row>
//               </Form>
//             </CardBody>
//           </Card>

//           {/* Results */}
//           {loading ? (
//             <div className='text-center my-5'>
//               <Spinner animation='border' role='status'>
//                 <span className='visually-hidden'>جاري التحميل...</span>
//               </Spinner>
//               <p className='mt-2'>جاري تحميل كشف الحساب...</p>
//             </div>
//           ) : data.length > 0 ? (
//             <>
//               {/* Summary */}
//               <Card className='mb-3'>
//                 <CardBody className='d-flex flex-wrap gap-3 justify-content-between'>
//                   <div>
//                     <div className='text-muted small'>إجمالي المدين</div>
//                     <div className='fw-bold'>{formatAmount(summary.totalDebit)}</div>
//                   </div>

//                   <div>
//                     <div className='text-muted small'>إجمالي الدائن</div>
//                     <div className='fw-bold'>{formatAmount(summary.totalCredit)}</div>
//                   </div>

//                   {summary.closing !== null && (
//                     <div>
//                       <div className='text-muted small'>الرصيد الختامي</div>
//                       <div className='fw-bold'>{formatAmount(n(summary.closing))}</div>
//                     </div>
//                   )}
//                 </CardBody>
//               </Card>

//               {/* Table */}
//               <div className='table-responsive' style={{ maxHeight: '65vh', overflow: 'auto' }}>
//                 <Table striped bordered hover className='mb-0'>
//                   <thead style={{ position: 'sticky', top: 0, zIndex: 1, backdropFilter: 'blur(20px)' }}>
//                     <tr>
//                       <th>التاريخ</th>
//                       <th>رقم المستند</th>
//                       <th>المراجع</th>
//                       <th>النوع</th>
//                       <th className='text-end'>دائن</th>
//                       <th className='text-end'>مدين</th>
//                       <th className='text-end'>الرصيد التراكمي</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {data.map((r, idx) => {
//                       const bal = n(r.runningBalance);
//                       return (
//                         <tr key={r.id || `${r.transDate}-${idx}`}>
//                           <td className='text-nowrap'>
//                             {r.transDate ? new Date(r.transDate).toLocaleDateString('en-US') : ''}
//                           </td>

//                           <td className='text-nowrap'>{r.docNo || '-'}</td>

//                           {/* ✅ روابط التفاصيل */}
//                           <td>{renderRefs(r)}</td>

//                           <td className='text-nowrap'>{getDocTypeAr(r.docType)}</td>

//                           <td className='text-end'>{formatAmount(r.credit)}</td>
//                           <td className='text-end'>{formatAmount(r.debit)}</td>
//                           <td className={`text-end fw-bold ${bal < 0 ? 'text-danger' : 'text-success'}`}>
//                             {formatAmount(bal)}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>

//               {/* تلميح سريع */}
//               <div className='text-muted small mt-2'>
//                 * اضغط على شارات المراجع لفتح صفحة التفاصيل (فاتورة/مشتريات/سداد).
//               </div>
//             </>
//           ) : (
//             <div className='text-center py-5'>
//               <p>لا توجد بيانات. اختر الفلاتر ثم اضغط "تحميل البيانات" لعرض التقرير.</p>
//             </div>
//           )}
//         </CardBody>

//         {data.length > 0 && (
//           <CardFooter className='text-muted'>تم إنشاء التقرير بتاريخ {new Date().toLocaleString('en-US')}</CardFooter>
//         )}
//       </Card>
//     </div>
//   );
// };

// export default ApLedgerTransactionsReport;


import { ntxAPI } from '@API/axiosNeatex';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import type { APIResponse } from '@store/Shared/shared';
import { TreeSelect } from 'antd';
import React, { useMemo, useState } from 'react';
import { Alert, Form, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// ======================
// Types
// ======================
interface ApLedgerRow {
  id: string;

  invId?: string | null;
  purId?: string | null;
  paymentId?: string | null;

  transDate: string; // ISO

  purCode?: string | null;
  invCode?: string | null;

  docNo: string | null;
  docType: string;
  description: string;

  debit: number;
  credit: number;
  runningBalance: number;
}

const n = (v: any) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

const formatNumber = (num: number | null | undefined, digits: number = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
    n(num)
  );
};

const getDocTypeAr = (docType?: string) => {
  if (!docType) return '-';
  const k = docType.replace(/\s+/g, '').toLowerCase();

  if (k === 'openingbalance') return 'الرصيد السابق';
  if (k === 'closingbalance') return 'الرصيد الختامي';
  if (k === 'creditmemo') return 'إشعار مدين';
  if (k === 'invoice') return 'فاتورة';
  if (k === 'payment') return 'سداد';
  if (k === 'standard') return 'قياسي';

  return docType;
};

const safeFileName = (s: string) => s.replace(/[\\/:*?"<>|]/g, '_');

// ======================
// Routes
// ======================
const ROUTES = {
  apInvoice: (id: string) => `/INV/Transactions/InvReceive/${id}/UpdateInvReceive`,
  purchase: (id: string) => `/PUR/PurchaseOrder/${id}/UpdatePurchaseOrder`,
  apPayment: (id: string) => `/AP/ApPayments/${id}/UpdateApPayments`
};

// ======================
// Component
// ======================
const ApLedgerTransactionsReport: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const { treeSuppliersData } = useGetSuppliersList();
  const { OperatingUnitOptions, loading: loadingOU } = useGetOperatingUnitWithPermission();

  const [data, setData] = useState<ApLedgerRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Filters
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
  const [fromDate, setFromDate] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');

  const resetFilters = () => {
    setOrganizationFilter(null);
    setSelectedSupplier(null);
    setFromDate('');
    setToDate('');
    setData([]);
    setError(null);
  };

  const applyFilters = async () => {
    setLoading(true);
    setError(null);

    try {
      if (!selectedSupplier) {
        setError(isAr ? 'اختر المورد أولاً' : 'Please select a supplier');
        setLoading(false);
        return;
      }

      // Handle date validation
      let startDate = fromDate;
      let endDate = toDate;

      if (startDate && endDate) {
        const ds = new Date(startDate).getTime();
        const de = new Date(endDate).getTime();
        if (Number.isFinite(ds) && Number.isFinite(de) && ds > de) {
          startDate = endDate;
          endDate = fromDate;
        }
      }

      const params = {
        StartDate: startDate,
        EndDate: endDate,
        OrganizationId: organizationFilter?.value || '',
        PeopleId: selectedSupplier
      };

      const res = await ntxAPI.get<APIResponse<ApLedgerRow[]>>('Reports/GetApLedgerTransactionsReport', { params });

      if (res.data?.succeeded === true) {
        setData(Array.isArray(res.data.data) ? res.data.data : []);
      } else {
        setError(res.data?.message || (isAr ? 'حدث خطأ غير معروف' : 'An unknown error occurred'));
      }
    } catch (err: any) {
      setError(err instanceof Error ? err.message : (isAr ? 'حدث خطأ غير معروف' : 'An unknown error occurred'));
    } finally {
      setLoading(false);
    }
  };

  // Summary calculation
  const summary = useMemo(() => {
    const rows = data || [];
    const totalDebit = rows.reduce((a, r) => a + n(r.debit), 0);
    const totalCredit = rows.reduce((a, r) => a + n(r.credit), 0);
    const openingBalance = rows.length > 0 ? n(rows[0].runningBalance) - n(rows[0].debit) + n(rows[0].credit) : 0;
    const endingBalance = rows.length ? n(rows[rows.length - 1].runningBalance) : 0;

    return { totalDebit, totalCredit, openingBalance, endingBalance };
  }, [data]);

  // Excel Export
  const exportToExcel = () => {
    if (!data?.length) return;

    const rows = data.map(r => ({
      [isAr ? 'التاريخ' : 'Date']: r.transDate ? new Date(r.transDate).toLocaleDateString('en-US') : '',
      [isAr ? 'رقم المستند' : 'Doc No']: r.docNo ?? '-',
      [isAr ? 'مرجع المشتريات' : 'Purchase Ref']: r.purCode ?? '',
      [isAr ? 'مرجع الفاتورة' : 'Invoice Ref']: r.invCode ?? '',
      [isAr ? 'النوع' : 'Type']: getDocTypeAr(r.docType),
      [isAr ? 'دائن' : 'Credit']: n(r.credit),
      [isAr ? 'مدين' : 'Debit']: n(r.debit),
      [isAr ? 'الرصيد التراكمي' : 'Balance']: n(r.runningBalance)
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    (wb as any).Workbook = { Views: [{ RTL: true }] };
    XLSX.utils.book_append_sheet(wb, ws, isAr ? 'كشف الحساب' : 'Ledger');

    const fileName = safeFileName(
      `AP_Ledger_${selectedSupplier || 'Supplier'}_${fromDate || 'ALL'}_${toDate || 'ALL'}.xlsx`
    );

    XLSX.writeFile(wb, fileName);
  };

  // Render reference links
  const renderRefs = (r: ApLedgerRow) => {
    const items: React.ReactNode[] = [];

    if (r.invId) {
      items.push(
        <Link
          key={`inv-${r.invId}`}
          to={ROUTES.apInvoice(r.invId)}
          className='badge bg-info bg-opacity-25 text-decoration-none text-body me-1'
          target='_blank'
          title={isAr ? 'فتح تفاصيل الحركة المخزنية' : 'Open inventory transaction'}
        >
          {r.invCode || (isAr ? 'الحركة المخزنية' : 'Inventory')}
        </Link>
      );
    }

    if (r.purId) {
      items.push(
        <Link
          key={`pur-${r.purId}`}
          to={ROUTES.purchase(r.purId)}
          className='badge bg-success bg-opacity-25 text-decoration-none text-body me-1'
          target='_blank'
          title={isAr ? 'فتح تفاصيل المشتريات' : 'Open purchase details'}
        >
          {r.purCode || (isAr ? 'مشتريات' : 'Purchase')}
        </Link>
      );
    }

    if (r.paymentId) {
      items.push(
        <Link
          key={`pay-${r.paymentId}`}
          to={ROUTES.apPayment(r.paymentId)}
          className='badge bg-primary bg-opacity-25 text-decoration-none text-body me-1'
          target='_blank'
          title={isAr ? 'فتح تفاصيل السداد' : 'Open payment details'}
        >
          {isAr ? 'سداد' : 'Payment'}
        </Link>
      );
    }

    return items.length ? <div className='d-flex flex-wrap gap-1'>{items}</div> : <span className='text-muted'>—</span>;
  };

  // Summary Cards Component
  const SummaryCards = () => {
    if (data.length === 0) return null;

    return (
      <div className='row g-3 mb-3'>  
        <div className='col-lg-4 col-md-6'>
          <Card className='card bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-arrow-up text-primary fa-xl'></i>
              </div>
              <div>
                <h6 className='text-primary fw-bold mb-1'>{isAr ? 'إجمالي المدين' : 'Total Debit'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(summary.totalDebit)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-4 col-md-6'>
          <Card className='card bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-arrow-down text-warning fa-xl'></i>
              </div>
              <div>
                <h6 className='text-warning fw-bold mb-1'>{isAr ? 'إجمالي الدائن' : 'Total Credit'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(summary.totalCredit)}</h4>
              </div>
            </div>
          </Card>
        </div>

      

        <div className='col-lg-4 col-md-6'>
          <Card className='card bg-success bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-flag-checkered text-success fa-xl'></i>
              </div>
              <div>
                <h6 className='text-success fw-bold mb-1'>{isAr ? 'الرصيد الختامي' : 'Closing Balance'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(summary.endingBalance)}</h4>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  };

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center'>
          {/* Organization */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-building text-primary'></i>
              </span>
              <Select
                isLoading={loadingOU}
                value={organizationFilter}
                onChange={setOrganizationFilter}
                options={OperatingUnitOptions}
                placeholder={isAr ? 'وحدة التشغيل' : 'Operating Unit'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Supplier */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-truck text-danger'></i>
              </span>
              <TreeSelect
                showSearch
                className='flex-grow-1'
                style={{ width: '100%', minHeight: '38px' }}
                treeLine
                allowClear
                treeDefaultExpandAll={false}
                value={selectedSupplier}
                onChange={(option: any) => setSelectedSupplier(option === null ? null : option)}
                treeData={treeSuppliersData}
                treeNodeFilterProp='title'
                placeholder={isAr ? 'اختر المورد' : 'Select Supplier'}
              />
            </div>
          </div>

          {/* From Date */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
                placeholder={isAr ? 'من تاريخ' : 'From Date'}
              />
            </div>
          </div>

          {/* To Date */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={toDate}
                onChange={e => setToDate(e.target.value)}
                min={fromDate || undefined}
                placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className='col-lg-2 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={resetFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>

            <button 
              className='btn btn-theme me-2' 
              type='button' 
              onClick={applyFilters} 
              disabled={loading}
              title={t('ApplyFilters')}
            >
              {loading ? (
                <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
              ) : (
                <i className='fas fa-filter fa-fw'></i>
              )}
            </button>

            <button
              className='btn btn-outline-success'
              type='button'
              onClick={exportToExcel}
              title={t('Export')}
              disabled={loading || data.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      {error && (
        <Alert variant='danger' className='mb-3'>
          {error}
        </Alert>
      )}

      <SummaryCards />

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover table-bordered mb-0'>
              <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
                <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small' style={{ minWidth: 100 }}>{isAr ? 'التاريخ' : 'Date'}</th>
                  <th className='small' style={{ minWidth: 150 }}>{isAr ? 'رقم المستند' : 'Doc No'}</th>
                  <th className='small' style={{ minWidth: 200 }}>{isAr ? 'المراجع' : 'References'}</th>
                  <th className='small' style={{ minWidth: 120 }}>{isAr ? 'النوع' : 'Type'}</th>
                  <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'دائن' : 'Credit'}</th>
                  <th className='small text-end' style={{ minWidth: 120 }}>{isAr ? 'مدين' : 'Debit'}</th>
                  <th className='small text-end' style={{ minWidth: 150 }}>{isAr ? 'الرصيد التراكمي' : 'Balance'}</th>
                </tr>
              </thead>

              <tbody>
                {!loading && data.length > 0 ? (
                  data.map((r, idx) => {
                    const balance = n(r.runningBalance);
                    return (
                      <tr key={r.id || `${r.transDate}-${idx}`} className='align-middle'>
                        <td className='text-center text-nowrap'>
                          {r.transDate ? new Date(r.transDate).toLocaleDateString('en-US') : '—'}
                        </td>
                        <td className='text-center text-nowrap'>{r.docNo || '—'}</td>
                        <td>{renderRefs(r)}</td>
                        <td className='text-nowrap'>{getDocTypeAr(r.docType)}</td>
                        <td className='text-end fw-bold'>{formatNumber(r.credit)}</td>
                        <td className='text-end fw-bold'>{formatNumber(r.debit)}</td>
                        <td className={`text-end fw-bold ${balance < 0 ? 'text-danger' : 'text-success'}`}>
                          {formatNumber(balance)}
                        </td>
                      </tr>
                    );
                  })
                ) : !loading ? (
                  <tr>
                    <td colSpan={7} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                        <small>{t('TryChangingFilters')}</small>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>

              {!loading && data.length > 0 && (
                <tfoot className='fw-bold bg-secondary bg-opacity-30'>
                  <tr>
                    <td colSpan={4} className='text-end'>
                      <span className='h6 m-0'>{isAr ? 'الإجمالي:' : 'Totals:'}</span>
                    </td>
                    <td className='text-end'>
                      <span className='h6 m-0'>{formatNumber(summary.totalCredit)}</span>
                    </td>
                    <td className='text-end'>
                      <span className='h6 m-0'>{formatNumber(summary.totalDebit)}</span>
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Loading>
      </Card>
    </>
  );
};

export default ApLedgerTransactionsReport;